import { useQuery } from "@tanstack/react-query";
import { getCustomerSupportFaqReadFaqListapi } from "../../../../api/support/faq";

export const useGetCustomerSupportFaqReadFaqList2 = (
  topicTypeIdx: number | null
) => {
  return useQuery({
    queryKey: ["getCustomerSupportFaqReadFaqList2", topicTypeIdx],
    queryFn: () => getCustomerSupportFaqReadFaqListapi(topicTypeIdx),
    select: (res) => res?.result,
    enabled: !!topicTypeIdx, // ✅ null일 땐 호출 안 함
  });
};
